module.exports = __webpack_public_path__ + "img/tarj1-3.bf9e6dc2.svg";